export function hashCode(str) {
    var hash = 0;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        let char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}

export function toggleFieldset(id) {
    var fieldset = jQuery('#fieldset_' + id);
    if (fieldset == null) {
        alert("Errore nel caricamento del fieldset");
        return;
    }
    if (fieldset.hasClass('hide')) {
        fieldset.show();
        fieldset.removeClass('hide');
    }
    else {
        fieldset.hide();
        fieldset.addClass('hide');
    }
}

export function printXLS(id)
{
    if (!id || id === '') {
        id = 'list';
    }
    let form = document.getElementById(id);
    let old_url = form.action;
    form.action = window.xlsPath;
    form.submit();
    form.action = old_url;
}
